/* unplugin-vue-components disabled */import { render } from "./WorkflowGraph.vue?vue&type=template&id=55242a56&scoped=true&ts=true"
import script from "./WorkflowGraph.vue?vue&type=script&lang=ts"
export * from "./WorkflowGraph.vue?vue&type=script&lang=ts"

import "./WorkflowGraph.vue?vue&type=style&index=0&id=55242a56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55242a56"]])

export default __exports__